(() => {
  const mount = (scope) => {
    scope.querySelectorAll('.sweet-formats-v9').forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const form = root.closest('form');
      if (!form) return;
      const cards = Array.from(root.querySelectorAll('.sweet-format-card'));
      const fields = () => Array.from(form.querySelectorAll('select.product-form__option-select'));
      const refresh = () => {
        const controls = fields();
        if (!controls.length) return;
        cards.forEach((card) => {
          const selected = controls.every((field, index) => field.value === card.getAttribute(`data-option-${index + 1}`));
          card.classList.toggle('is-selected', selected);
          if (selected) card.setAttribute('aria-current', 'true');
          else card.removeAttribute('aria-current');
        });
      };
      root.addEventListener('click', (event) => {
        const card = event.target.closest('.sweet-format-card');
        if (!card || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const controls = fields();
        if (!controls.length || !controls.every((field, index) => Array.from(field.options).some((option) => option.value === card.getAttribute(`data-option-${index + 1}`)))) return;
        event.preventDefault();
        controls.forEach((field, index) => { field.value = card.getAttribute(`data-option-${index + 1}`); });
        controls[0].dispatchEvent(new Event('change', { bubbles: true }));
        refresh();
      });
      form.addEventListener('change', refresh);
      refresh();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  else mount(document);
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
})();
